import React from "react"
import { formatEmailForApi } from "@mallardbay/lib-shared-helpers"

import { INPUT_TYPES } from "~config/constants"

import TextInput from "./text-input"
import type { Props } from "./text-input"

export default function EmailInput({ onChange, ...props }: Props) {
    return (
        <TextInput
            {...props}
            onChange={(text) => onChange(formatEmailForApi(text))}
            type={INPUT_TYPES.EMAIL}
        />
    )
}

// For refrence:
// Using type input makes some browsers not fire on change when there's trailing spaces
// https://github.com/facebook/react/issues/14897#issuecomment-466662067
